// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const CELLTRION_FIELD_ALIASES = {
  hospitalName: ['병의원명'],
  drugName: ['제품명'],
  unitPrice: ['약가'],
  quantity: ['수량'],
  prescriptionAmount: ['처방금액'],
  settlementAmount: ['수수료합계'],
  feeRate: ['합계(%)'],
  note: ['비고'],
  pharmaceuticalCompanyName: ['제약사명'],
};

const REQUIRED_HEADERS = [
  '순번',
  '처방월',
  '병의원명',
  '제품명',
  '약가',
  '수량',
  '처방금액',
  '수수료합계',
  '합계(%)',
  '기본수수료',
  '추가수수료',
  '추가(%)',
  '실적구분',
  '구분',
  '비고',
  '제약사명',
];

function isCelltrionProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const celltrionPharmTemplate = {
  id: 'celltrion-pharm',
  name: '셀트리온제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isCelltrionProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isCelltrionProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(CELLTRION_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: cleanText(
          row[columnMap.pharmaceuticalCompanyName],
        ),
        customerName: row[columnMap.hospitalName],
        drugName,
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '셀트리온제약',
      templateName: this.name,
    };
  },
};

export default celltrionPharmTemplate;
